import http, { url } from '../../../http'

const API_URL = "followup"

class MeetingAPI {

  async save(meeting) {
    const response = await http(`${API_URL}/save`, 'POST', meeting)
    return response || null
  }

  async get(meetingID) {
    const response = await http(`${API_URL}-employee/show-details/${meetingID}`)
    return response || null
  }

  async getActs(copasstID, page) {
    const response = await http(`${API_URL}/${copasstID}?page=${page}`, 'GET')
    return response || null
  }

  async update(meetingID, meeting) {
    const response = await http(`${API_URL}/update/${meetingID}`, 'PUT', meeting)
    return response || null
  }

  async saveMember(meetingID, memberID) {
    const response = await http(`${API_URL}-employee/save`, 'POST', {
      followup_report_header_id: meetingID,
      employee_id: memberID,
    })
    return response || null
  }

  async getMembers(copasstID) {
    const response = await http(`${API_URL}-employee/show-members/${copasstID}`, 'GET')
    return response || null
  }

  getWord(meetingID) {
    return url(`followup-copasst-act/${meetingID}`)
  }

}

export default new MeetingAPI()